// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { listStyles } from "@guestsupply/Overrides/Widgets/MyLists/MyListsList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

listStyles.messageText = {
    ...dataTableStyles.noResultsText,
};

listStyles.notifyWrapper = {
    css: css`
        width: 100%;
        display: flex;
        align-items: flex-start;
    `,
};

listStyles.cardList = {
    gridContainer: {
        gap: 0,
    },
};

listStyles.cardContainer = {
    cardDivider: {
        css: css`
            width: 100%;
            padding-top: 20px;
            padding-bottom: 20px;
            margin: 0;
            background: ${getColor("common.white")};
            &:first-child {
                border-top: 1px solid ${getColor("common.border")};
            }
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
};
